import {apiUrl} from "../../../../../settings";

export const withdrawalUrl = () => {
    return `${apiUrl}/gic/withdrawal`
}

export const getGicBalanceUrl = () => {
    return `${apiUrl}/gic/getGicBalance`
}
